// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container {
    z-index: 5;
    border: 1px solid var(--gordons-green-bright);
    background-color: var(--approx-nero);
    border-radius: 8px;
    max-width: 1224px;
    width: calc(100% - 40px);
    margin: 24px auto 0;
    padding: 12px 24px;
}

.navbar-logo {
    width: 160px;
}

.navbar-container-wrap {
    width: 100%;
    max-width: 1224px;
    min-height: 30px;
    margin-left: auto;
    margin-right: auto;
}

.navbar-wrapper {
    justify-content: space-between;
    align-items: center;
    display: flex;
}

.nav-button-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    align-items: center;
    display: flex;
}

@media screen and (max-width: 991px) {
    .nav-button-wrapper {
        width: 100%;
        margin-left: 0;
    }
}

@media screen and (max-width: 767px) {

}

@media screen and (max-width: 479px) {

}

@media screen and (max-width: 340px) {
    .nav-right {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Navbar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,6CAA6C;IAC7C,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".navbar-container {\n    z-index: 5;\n    border: 1px solid var(--gordons-green-bright);\n    background-color: var(--approx-nero);\n    border-radius: 8px;\n    max-width: 1224px;\n    width: calc(100% - 40px);\n    margin: 24px auto 0;\n    padding: 12px 24px;\n}\n\n.navbar-logo {\n    width: 160px;\n}\n\n.navbar-container-wrap {\n    width: 100%;\n    max-width: 1224px;\n    min-height: 30px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.navbar-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n}\n\n.nav-button-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    align-items: center;\n    display: flex;\n}\n\n@media screen and (max-width: 991px) {\n    .nav-button-wrapper {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n@media screen and (max-width: 767px) {\n\n}\n\n@media screen and (max-width: 479px) {\n\n}\n\n@media screen and (max-width: 340px) {\n    .nav-right {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
